window.addEventListener("load", () => {
    const formSuccess = document.getElementById('product-quotation').getAttribute('data-form-success');
    const formSuccessMessage = document.getElementById('product-quotation').getAttribute('data-form-success-message');

    const overlay = document.querySelector("#modal-contact-dark-overlay");
    const modal = document.querySelector("#contact-modal-container");

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    const showOverlay = () => overlay.classList.add('show-overlay-modal');
    const showModal = () => modal.classList.add('show-contact-modal');
    const hideOverlay = () => overlay.classList.remove('show-overlay-modal');
    const hideModal = () => modal.classList.remove('show-contact-modal'); // Open the Modal Window
    const hideFormFields = () => document.querySelector('#contact-modal-form-content').classList.add('hide-modal-content');// Show success message on page load        

    const closeHandler = function (event) {
        if (event.target === document.querySelector('#contact-modal-container')) {
            hideOverlay();
            hideModal();
            window.removeEventListener("click", closeHandler);
        }
    };

    if (formSuccess === 'true') {
        hideFormFields();
        showOverlay();
        showModal();
        document.querySelector('#modal-success-message').innerHTML = formSuccessMessage;
    }

    document.querySelector("#quotation-modal-button").addEventListener("click", () => {
        showOverlay();
        showModal();
        window.addEventListener("click", closeHandler);
    });

    document.querySelector("#contact-modal-exit").addEventListener("click", () => {
        hideOverlay();
        hideModal();
        window.removeEventListener("click", closeHandler);
    });
});